import React from "react";
import "./Footer.scss";

function Footer() {
  return (
    <>
      <div className="footer_section">
        <div className="footer_content">
          <p>&copy;Nkwo Chukwuemeka</p>
        </div>
      </div>
    </>
  );
}

export default Footer;
